"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Card_1 = __importStar(require("~/components/company/item_mini_no_price/Card"));
var COLUMN_COUNT_SP = 2;
var COLUMN_COUNT_PC = 6;
var MIN_PAGE = 1;
// FIXME: カールセールの動作はカテゴリページにあるものと同じなのでいい感じに共通化できたら嬉しい
var List = function (_a) {
    var isSmartPhone = _a.isSmartPhone, items = _a.items;
    var displayContentCount = react_1.default.useState(isSmartPhone ? COLUMN_COUNT_SP : COLUMN_COUNT_PC)[0];
    var maxPage = react_1.default.useState(Math.ceil(items.length / displayContentCount))[0];
    var _b = react_1.default.useState(1), page = _b[0], setPage = _b[1];
    var _c = react_1.default.useState(0), marginLeft = _c[0], setMarginLeft = _c[1];
    var paginate = function (page) {
        setMarginLeft((Card_1.CARD_WIDTH * displayContentCount) * (page - 1) * -1);
        setPage(page);
    };
    var handleClickLeftArrow = function () {
        if (page > MIN_PAGE) {
            paginate(page - 1);
        }
    };
    var handleClickRightArrow = function () {
        if (page < maxPage) {
            paginate(page + 1);
        }
    };
    return (react_1.default.createElement("div", { className: "companyShow-ItemListContainer" },
        react_1.default.createElement("div", { className: "companyShow-ItemList" },
            react_1.default.createElement("div", { onClick: handleClickLeftArrow, className: (0, classnames_1.default)("companyShow-ItemList_Arrow", "companyShow-ItemList_Arrow-left", { "companyShow-ItemList_Arrow-disabled": page === MIN_PAGE }) },
                react_1.default.createElement("i", { className: "fa fa-chevron-left" })),
            react_1.default.createElement("div", { className: "companyShow-ItemList_Inner" },
                react_1.default.createElement("div", { className: "companyShow-ItemList_InnerPaginate", style: { marginLeft: marginLeft } }, items.map(function (item, idx) { return (react_1.default.createElement(Card_1.default, { key: idx, item: item })); }))),
            react_1.default.createElement("div", { onClick: handleClickRightArrow, className: (0, classnames_1.default)("companyShow-ItemList_Arrow", "companyShow-ItemList_Arrow-right", { "companyShow-ItemList_Arrow-disabled": page === maxPage }) },
                react_1.default.createElement("i", { className: "fa fa-chevron-right" })))));
};
exports.default = List;
